var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionBackpackColoredDay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5C22 4.44772 21.5523 4 21 4H3C2.44772 4 2 4.44772 2 5V19C2 19.5523 2.44772 20 3 20H21C21.5523 20 22 19.5523 22 19V5Z",
    fill: "url(#paint0_linear_9_8499)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16C9.55228 16 10 16.4477 10 17V17C10 17.5523 9.55228 18 9 18H5C4.44772 18 4 17.5523 4 17V17C4 16.4477 4.44772 16 5 16H9Z",
    fill: "#AB89E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13C10 13.5523 9.55228 14 9 14H5C4.44772 14 4 13.5523 4 13V13C4 12.4477 4.44772 12 5 12H9C9.55228 12 10 12.4477 10 13V13Z",
    fill: "#AB89E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C12 8.55228 11.5523 9 11 9H5C4.44772 9 4 8.55228 4 8V8C4 7.44772 4.44772 7 5 7H11C11.5523 7 12 7.44772 12 8V8Z",
    fill: "#AB89E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 17H15V16H16V17H17V16H18V17H19V13H14V17ZM16 14C16.5523 14 17 14.4477 17 15C17 15.5523 16.5523 16 16 16C15.4477 16 15 15.5523 15 15C15 14.4477 15.4477 14 16 14Z",
    fill: "#FFC30D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12V13H20V12L16.5 4L13 12Z",
    fill: "url(#paint1_linear_9_8499)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17H16V16H15V17H14V16H13V20H20V16H19V17H18V16H17V17Z",
    fill: "#FFC30D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_8499",
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#732EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5714CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_8499",
    x1: 13,
    y1: 12,
    x2: 20,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC30D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionBackpackColoredDay);
export default __webpack_public_path__ + "static/media/ic_action_backpack_colored_day.ac7da787262d9a34aa1279814f93a59f.svg";
export { ForwardRef as ReactComponent };